import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    customersDataReport: selectors.customersDataReportSelector(state),
    error: selectors.errorSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isCustomersDataLoading'),
    isLoadingCsv: selectors.isLoadingSelector(state, 'isCustomersCsvDataLoading')
  }
}

const mapDispatchToProps = {
  fetchCustomersDataReport: actions.fetchCustomersDataReport,
  fetchCustomersCsvDataReport: actions.fetchCustomersCsvDataReport
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
